import React from "react";

import { SuiteBuilderPromoBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { SuiteSnapshotBlock } from "./SuiteSnapshotBlock";

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
    suite_snapshot: SuiteSnapshotBlock,
};

export const SuiteBuilderPromoBlock = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField components={components} value={value.items} />
        </Themed>
    );
};
